/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import t from"./PointCloudBitfieldFilter.js";import o from"./PointCloudFilter.js";import i from"./PointCloudReturnFilter.js";import r from"./PointCloudValueFilter.js";const e={key:"type",base:o,typeMap:{value:r,bitfield:t,return:i}};export{e as types};
